import { Breadcrumb } from 'src/feature/bite/component';
import { useGetDetail } from '../context/useQuery';

import { useIntl } from 'react-intl';
import Detail from '../component/Detail';

export default function TerminalDetail() {
  const intl = useIntl();

  const { isLoading } = useGetDetail()

  return (
    <>
      <Breadcrumb parentPage={intl.formatMessage({ id: 'TERMINAL_PLURAL' })} currentPage={intl.formatMessage({ id: 'TERMINAL_SINGLE' })} />
      <Detail isLoading={isLoading} />
    </>
  )
}
